/* ===== Task #215: hide Judge.me reviews rated below 3 stars (client-side) =====
   Store owner wants only reviews rated 3 stars and up visible on the storefront. Judge.me's
   own "auto-publish by rating" setting (Settings > Moderation in the Judge.me admin) does NOT
   apply to reviews synced in from the Shopify "Shop" app -- confirmed via Judge.me's own help
   docs: Shop-app reviews always auto-publish regardless of that setting and can't be
   individually hidden from Judge.me's own moderation screen. So this filters by star rating
   here in the theme instead, client-side, regardless of where a given review came from
   (Shop app or Judge.me's normal review-request flow).

   Selector used (verified live against the JEREMIAH29 Hoodie PDP's real rendered widget, not
   guessed): each individual review renders as a `.jdgm-rev` element inside
   `#judgeme_product_reviews .jdgm-rev-widg__reviews`. Each one carries its own
   `.jdgm-rev__rating` span with a `data-score="N"` attribute (also mirrored in that span's
   aria-label, e.g. "5 star review", and in N filled `.jdgm-star.jdgm--on` children) -- reading
   `data-score` off `.jdgm-rev__rating` is the simplest reliable source, so that's the only
   thing this script reads. Nothing else in the widget carries the `.jdgm-rev` class, so the
   write-a-review CTA, the overall rating summary/average pill, and the sort/filter controls
   are never touched by this script.

   Judge.me renders/re-renders its widget asynchronously after this script loads, and again on
   pagination (the widget's own `.jdgm-paginate` control fetches more reviews from
   reviews_for_widget and swaps them into the same `.jdgm-rev-widg__reviews` container without a
   full page reload) -- so a one-shot pass on load isn't enough. A MutationObserver on the
   widget root re-runs the filter on every DOM change Judge.me makes, the same pattern this
   theme already uses elsewhere for async third-party app content (see relocateWishForPreorder's
   observer in assets/theme.js).

   IMPORTANT, tell the merchant: the widget's own "N reviews" / "X.X average" summary numbers
   are computed by Judge.me server-side from ALL of a product's reviews before this script ever
   runs -- hiding individual low-rated reviews here does not, and cannot, change that summary
   number. That mismatch (e.g. "4.2 average, 12 reviews" header above a list that visibly shows
   fewer than 12 entries) is expected and out of scope for a client-side-only fix; changing the
   summary itself would require Judge.me to actually unpublish/delete the underlying reviews on
   their side, which their moderation UI can't do for Shop-app-sourced reviews (see above). */
(function () {
  var MIN_RATING = 3;

  function hideLowRatedReviews(container) {
    if (!container) return;
    var reviews = container.querySelectorAll('.jdgm-rev');
    for (var i = 0; i < reviews.length; i++) {
      var rev = reviews[i];
      var ratingEl = rev.querySelector('.jdgm-rev__rating');
      if (!ratingEl) continue;

      var score = parseFloat(ratingEl.getAttribute('data-score'));
      if (isNaN(score)) continue;

      if (score < MIN_RATING) {
        if (rev.style.display !== 'none') { rev.style.display = 'none'; }
        rev.setAttribute('data-yg-rating-hidden', 'true');
      } else if (rev.getAttribute('data-yg-rating-hidden') === 'true') {
        // Defensive: if Judge.me ever re-uses/re-scores an existing node (e.g. on re-sort),
        // make sure a review we previously hid gets shown again once it reads >= MIN_RATING.
        rev.style.display = '';
        rev.removeAttribute('data-yg-rating-hidden');
      }
    }
  }

  function initReviewRatingFilter() {
    var widgetRoot = document.getElementById('judgeme_product_reviews');
    if (!widgetRoot) return;

    // First pass: covers the case where Judge.me already finished rendering by the time this
    // script runs (e.g. fast connections / cached widget data).
    hideLowRatedReviews(widgetRoot);

    if (!window.MutationObserver) return;

    var reviewObserver = new MutationObserver(function () {
      hideLowRatedReviews(widgetRoot);
    });
    reviewObserver.observe(widgetRoot, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initReviewRatingFilter);
  } else {
    initReviewRatingFilter();
  }
})();
